module.exports = __webpack_public_path__ + "img/surat-agenda.59b8ca6d.svg";